import {
  BCP_47_LOCALES
} from "@backmarket/http-api/src/standards/Locale";
import { round } from "@backmarket/utils/math/round";
import translations from "../../translations/distances.translations.js";
export default function createDistanceFormatter(locale, messageFormatter) {
  const MILE_PER_METER = 621371e-9;
  const FEET_PER_METER = 3.28084;
  const MAX_FEET_CUTOFF = 528;
  const useImperial = (/* @__PURE__ */ new Set([
    BCP_47_LOCALES.en_US,
    BCP_47_LOCALES.en_GB
    // 'en-lr',
    // 'my-mm',
  ])).has(locale);
  function feetFormatter(distance) {
    return messageFormatter(translations.footShort, { distance });
  }
  function mileFormatter(distance) {
    return messageFormatter(translations.mileShort, { distance });
  }
  function meterFormatter(distance) {
    return messageFormatter(translations.meterShort, { distance });
  }
  function kilometerFormatter(distance) {
    return messageFormatter(translations.kilometerShort, { distance });
  }
  return (meters) => {
    if (useImperial) {
      const roundedFeet = round(meters * FEET_PER_METER, -1);
      return roundedFeet < MAX_FEET_CUTOFF ? feetFormatter(roundedFeet) : mileFormatter(round(meters * MILE_PER_METER, 1));
    }
    const roundedMeters = round(meters, -1);
    if (roundedMeters < 1e3) {
      return meterFormatter(roundedMeters);
    }
    if (roundedMeters < 1e4) {
      return kilometerFormatter(round(roundedMeters / 1e3, 1));
    }
    return kilometerFormatter(round(roundedMeters / 1e3, 0));
  };
}
